module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-stage"
  }, [(!_vm.customerStage.id) ? _c('div', {
    staticClass: "noSetStage"
  }, [_c('p', {
    staticClass: "first"
  }, [_c('span', [_vm._v("暂未设置客户阶段 ")]), _vm._v(" "), (_vm.permission) ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.isChangeStage()
      }
    }
  }, [_vm._v("跳转至第一阶段")]) : _vm._e()], 1), _vm._v(" "), (_vm.permission) ? _c('p', {
    staticClass: "second"
  }, [_vm._v("（更多阶段可点击上方的客户阶段标签）")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.customerStage.id) ? _c('div', {
    staticClass: "curStage"
  }, [(_vm.customerStage.type !== 2) ? _c('div', {
    staticClass: "curStage-title"
  }, [_c('i', {
    staticClass: "title-icon",
    class: _vm.allFinishWork ? 'web-icon-finish' : 'web-icon-progress'
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.customerStage.name) + " —工作完成" + _vm._s(_vm.finishState))])]) : _c('div', {
    staticClass: "curStage-title"
  }, [_c('i', {
    staticClass: "title-icon el-icon-warning lose"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.customerStage.name))])]), _vm._v(" "), _c('div', {
    staticClass: "curStage-content"
  }, [(_vm.customerStage.type === 2) ? _c('div', {
    staticClass: "curStage-work lose-because"
  }, [_c('div', {
    staticClass: "lose-flex"
  }, [_c('span', {
    staticClass: "lose-title"
  }, [_vm._v("流失原因")]), _vm._v(" "), _c('span', {
    staticClass: "lose-text"
  }, [_vm._v(_vm._s(_vm.wastageReason.reason))])]), _vm._v(" "), _c('div', {
    staticClass: "lose-flex"
  }, [_c('span', {
    staticClass: "lose-title"
  }, [_vm._v("流失备注")]), _vm._v(" "), _c('p', {
    staticClass: "lose-text"
  }, [_vm._v(_vm._s(_vm.wastageReason.memo))])])]) : _c('div', {
    staticClass: "curStage-work"
  }, [(_vm.curWorkArray.length) ? _c('div', {
    staticClass: "workList"
  }, [_vm._l((_vm.curWorkArray), function(work) {
    return _c('div', {
      key: work.id,
      staticClass: "work-item"
    }, [_c('el-checkbox', {
      on: {
        "change": function($event) {
          _vm.isFinshedWork(work)
        }
      },
      model: {
        value: (work.isFinished),
        callback: function($$v) {
          _vm.$set(work, "isFinished", $$v)
        },
        expression: "work.isFinished"
      }
    }, [(work.isRequired) ? _c('span', {
      staticClass: "isRequired"
    }, [_vm._v("* ")]) : _vm._e(), _vm._v(_vm._s(work.name))]), _vm._v(" "), (work.isFinished) ? _c('p', {
      staticClass: "hint"
    }, [_vm._v(_vm._s(work.userName) + "于" + _vm._s(work.finishedTime) + "完成")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.allFinishWork) ? _c('p', {
    staticClass: "finish-hint"
  }, [_vm._v("工作全部完成啦！请及时填写反馈并变更阶段哦！")]) : _vm._e()], 2) : _c('div', {
    staticClass: "workList"
  }, [_c('p', {
    staticClass: "noWorkList"
  }, [_vm._v("该阶段未设置工作指引")])]), _vm._v(" "), _c('div', {
    staticClass: "curStage-butArr"
  }, [_c('span', {
    staticClass: "feedback",
    class: {
      'open-feedback': _vm.curFeedback
    },
    on: {
      "click": function($event) {
        _vm.curFeedback = !_vm.curFeedback
      }
    }
  }, [_vm._v("共" + _vm._s(_vm.curCommentArray.length) + "条反馈")]), _vm._v(" "), (_vm.permission && _vm.isJumpStage) ? _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.isChangeStage()
      }
    }
  }, [_vm._v("跳转下阶段")]) : _vm._e()], 1)]), _vm._v(" "), (_vm.curFeedback) ? _c('div', {
    staticClass: "curStage-feedback"
  }, [(_vm.permission) ? _c('div', {
    staticClass: "submit"
  }, [_c('stage-comment-box', {
    attrs: {
      "refType": "customerStage",
      "refId": _vm.customerStage.id,
      "customerId": _vm.id
    },
    on: {
      "refresh": _vm.getNowStage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.curCommentArray.length) ? _c('ul', {
    staticClass: "com-list"
  }, _vm._l((_vm.curCommentArray), function(comment) {
    return _c('li', {
      key: comment.id,
      staticClass: "com-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(comment.name))])]), _vm._v(" "), _c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "width": "36",
        "height": "36",
        "src": comment.avatar
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "post-time"
    }, [_vm._v(_vm._s(comment.addTime))]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [(comment.refUserName) ? _c('span', {
      staticClass: "at"
    }, [_vm._v(_vm._s('@' + comment.refUserName))]) : _vm._e(), _vm._v("\n                " + _vm._s(comment.content) + "\n              ")]), _vm._v(" "), _c('ul', {
      staticClass: "gallery-wrap"
    }, _vm._l((_vm.strToArr(comment.images)), function(img) {
      return _c('li', {
        key: img.uid,
        staticClass: "img"
      }, [_c('img', {
        attrs: {
          "width": "80",
          "height": "80",
          "src": img.url || img
        },
        on: {
          "click": function($event) {
            _vm.openLightbox(img)
          }
        }
      })])
    })), _vm._v(" "), (comment.attachment.length) ? _c('attachment-preview', {
      attrs: {
        "data": _vm.jsonStringify(comment.attachment)
      }
    }) : _vm._e()], 1)
  })) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.historyStageData.length) ? _c('div', {
    staticClass: "perStage"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "perStage-content"
  }, _vm._l((_vm.historyStageData), function(historyStage, index) {
    return _c('div', {
      key: index,
      staticClass: "stage-item"
    }, [_c('p', {
      staticClass: "perStage-title"
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(historyStage.customerStage.name))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(historyStage.customerStage.intoTime) + "~" + _vm._s(historyStage.customerStage.outTime) + " （历时：" + _vm._s(historyStage.customerStage.stayTime) + "）")])]), _vm._v(" "), _c('div', {
      staticClass: "stage-content"
    }, [_c('div', {
      staticClass: "perStage-common perStage-work"
    }, [_c('span', {
      staticClass: "type"
    }, [_vm._v("工作")]), _vm._v(" "), (!historyStage.workArray.length) ? _c('div', {
      staticClass: "noFeedback"
    }, [_vm._v("该阶段未设置工作指引。")]) : _c('div', {
      staticClass: "perStage-work-content"
    }, _vm._l((historyStage.workArray), function(preWork) {
      return _c('div', {
        key: preWork.id,
        staticClass: "work-item"
      }, [_c('el-checkbox', {
        attrs: {
          "label": "a",
          "disabled": ""
        },
        model: {
          value: (preWork.isFinished),
          callback: function($$v) {
            _vm.$set(preWork, "isFinished", $$v)
          },
          expression: "preWork.isFinished"
        }
      }, [(preWork.isRequired) ? _c('span', {
        staticClass: "isRequired"
      }, [_vm._v("* ")]) : _vm._e(), _vm._v(_vm._s(preWork.name))]), _vm._v(" "), (preWork.isFinished) ? _c('p', {
        staticClass: "hint"
      }, [_vm._v(_vm._s(preWork.userName) + "，于" + _vm._s(preWork.finishedTime) + "完成")]) : _vm._e()], 1)
    }))]), _vm._v(" "), _c('div', {
      staticClass: "perStage-common perStage-feedback"
    }, [_c('span', {
      staticClass: "type"
    }, [_vm._v("反馈")]), _vm._v(" "), (!historyStage.commentArray.length) ? _c('div', {
      staticClass: "noFeedback"
    }, [_vm._v("该阶段未填写反馈。")]) : _c('div', {
      staticClass: "perStage-feedback-content"
    }, [_c('ul', {
      staticClass: "com-list"
    }, _vm._l((historyStage.commentArray), function(comment) {
      return _c('li', {
        key: comment.id,
        staticClass: "com-item"
      }, [_c('div', {
        staticClass: "title"
      }, [_c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(comment.name))])]), _vm._v(" "), _c('div', {
        staticClass: "avatar"
      }, [_c('img', {
        attrs: {
          "width": "36",
          "height": "36",
          "src": comment.avatar
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "post-time"
      }, [_vm._v(_vm._s(comment.addTime))]), _vm._v(" "), _c('div', {
        staticClass: "desc"
      }, [(comment.refUserName) ? _c('span', {
        staticClass: "at"
      }, [_vm._v(_vm._s('@' + comment.refUserName))]) : _vm._e(), _vm._v("\n                      " + _vm._s(comment.content) + "\n                    ")]), _vm._v(" "), _c('ul', {
        staticClass: "gallery-wrap"
      }, _vm._l((_vm.strToArr(comment.images)), function(img) {
        return _c('li', {
          key: img.uid,
          staticClass: "img"
        }, [_c('img', {
          attrs: {
            "width": "80",
            "height": "80",
            "src": img.url || img
          },
          on: {
            "click": function($event) {
              _vm.openLightbox(img)
            }
          }
        })])
      })), _vm._v(" "), (comment.attachment.length) ? _c('attachment-preview', {
        attrs: {
          "data": _vm.jsonStringify(comment.attachment)
        }
      }) : _vm._e()], 1)
    }))])])])])
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "perStage-title"
  }, [_c('i', {
    staticClass: "title-icon web-icon-history"
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("历史工作与反馈")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6002f8ca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/customer/customer-stage.vue
// module id = 1286
// module chunks = 82